import { resourcesService } from "app/services";
import { useQuery } from "@tanstack/react-query";

export function useFrecuenciasDePago() {
  const frecuenciasDePago = useQuery({
    queryKey: ["frecuencias-de-pago"],
    queryFn: resourcesService.getFrecuenciasDePago,
  });

  return frecuenciasDePago;
}
